import { createSvgIcon } from '@mui/material';

export const ToastErrorIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none">
    <circle cx="9.99999" cy="9.99996" r="7.83333" stroke="#DD3F33" />
    <path d="M10 5.83337L10 10.8334" stroke="#DD3F33" stroke-linecap="round" />
    <circle cx="9.99999" cy="13.3333" r="0.833333" fill="#DD3F33" />
  </svg>,
  'ToastErrorIcon',
);
